import React, { useEffect } from 'react';
import Header from '../components/Layout/Header/Header';
import Footer from '../components/Layout/Footer/Footer';
import NotFound from '../components/Pages/NotFound/NotFound';
import { useScrollState } from '../stores/scrollStore';

const NotFoundPage: React.FC = () => {
  const { isScrolled, scrollProgress, throttledUpdateScrollState } = useScrollState();

  useEffect(() => {
    // Use throttled scroll handler for native scrolling
    const handleScroll = () => {
      throttledUpdateScrollState(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [throttledUpdateScrollState]);

  return (
    <>
      <Header isScrolled={isScrolled} scrollProgress={scrollProgress} />
      <div>
        <NotFound />
        <Footer />
      </div>
    </>
  );
};

export default NotFoundPage;
